<template>
  <div name="challengepupils">
    <div class="w-11/12 px-4 mb-4 bg-white h-12 flex content-center justify-between">
        <div>
        <input 
          type="search"
          class="filter-bar-search w-48 focus:outline-none"
          name="search"
          v-model="search"
          placeholder="Enter search term..."
        />
        <i class="fas fa-times text-sm absolute -ml-8 mt-4 cursor-pointer hover:opacity-50" 
            @click="clearTags()" 
            title="Clear search" v-show="search.length > 0"></i>
      </div>

                    <div class="inline-block">
                       <dropdown v-if="classesArray.length > 0" :options="classDropdown" :css="'text-gray-700'" 
                        :selected="selectedClass" v-on:updateOption="classSelect" 
                        class="w-56 bg-white border rounded text-center  mb-6" ></dropdown>
                  </div>


                  <div class="inline-block">
                         <div class="pl-3 rounded filter-date inline-block"> 
                              <datetime v-model="eventDate" input-class="date-input"  placeholder="Select date"
                         :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
                         :auto=true ></datetime> 
                        </div>
                              </div>
     
            </div>


                <div v-if="errored" class="empty">
                    <p>We are not able to retrieve this information at the moment, please try back later</p>
                  </div>



                <div id="content-area" v-else>
                  <div style="width:100%; text-align:center;" v-if="loading" >
                    <i class="spinner fa fa-spinner fa-spin"></i>
                  </div>

                    <div v-else>

                    <div class="bg-white h-3/4 pb-4 max-h-screen overflow-y-scroll" v-if="componentLoaded" >
                         <table class="w-full">
                          <thead class="bg-gray-100 w-full">
                          <th class="text-sm w-2/5 text-left p-4 pl-2">Pupil</th>
                             <th class="text-sm w-2/5 text-left pl-10">Date</th>
                             <th class="text-sm w-1/5 text-right pr-16">Result</th>
                             </thead>
                         </table>
                       <table class="w-full mb-6  ">
                    <tr v-for="row in filteredList" :key="row.identifier" class="bg-white even:bg-gray-200">
                      <td class="text-sm w-2/5">{{getPupilName(row.register_identifier)}}</td>
                      <td class="text-sm w-2/5">{{parseDate(row.result_date)}} </td>
                      <td class="text-base text-purple-600 font-semibold text-right w-1/5 pr-10">
                         {{parseResult(row.result)}} <span class="text-xs">{{suffix}}</span>
                      </td>
                    </tr>
                  </table>
                    </div>
                     <p class="m-5 mx-12" v-else>We could not find any data for your given selection.</p>
              </div>
</div>
  </div>
</template>

<script>
import moment from 'moment'
import { Datetime } from 'vue-datetime';

import { mapGetters } from 'vuex'
import { pupilMixin } from "@/mixins/pupilMixin.js";

import { ChallengeService } from "@/services/challenge.service";

const dropdown = () => import('@/components/Dropdown.vue')

const Layouts = {COUNTER: 1, TIMEWITHCOUNT: 2, DISTANCE: 3, TIME: 4 }

export default {
  name: 'challengepupils',
  mixins: [pupilMixin],
   props: {
    },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess"
    }),
    classDropdown () {
      var results = [{ id: 0, name: "Showing All Classes" }].concat(this.classesArray);
      this.selectedClass = results[0];

      return results
    },
    componentLoaded () {
      return this.filteredList.length > 0
    },
    suffix() {
      if (this.challenge.layout_id === Layouts.TIME ) {
        return "mins"
      } else if (this.challenge.layout_id === Layouts.DISTANCE ) {
        return "meters"
      } else {
      return 'times'
      }
    },
    orderedResults() {
      const vm = this;
      let challengeChosen = vm.challenge
        
      let filteredResults = vm.results.filter(function(result) {
          let filtered = true;

          filtered = result.challenge_identifier === challengeChosen.identifier
          
          if (filtered) {
            if (vm.eventDate.length > 0) {
              let dt1 = moment(vm.eventDate).format('YYYY-MM-DD');
              let dt2 = moment(result.result_date).format('YYYY-MM-DD');
              filtered = moment(dt1).isSame(dt2);
            }
          }

          return filtered;
        });

        return _.orderBy(filteredResults, ["result", "result_date"], "desc");
    },
    filteredList() {
      var vm = this;
      let pupilFilter = this.pupilArray
      .filter(function(pupil) {
        
         let filtered = true;
         if (vm.selectedClass.id > 0) {
           filtered = pupil.class === vm.selectedClass.name;
         }

         if (filtered) {
           filtered = pupil.name.toLowerCase().includes(vm.search.toLowerCase())
         }
         return filtered 
       })
      .map(p => p.identifier)

     return this.orderedResults.filter(r => pupilFilter.includes(r.register_identifier))
   }
  },
  data () {
    return {
      loading: true,
      school: this.$store.getters.school,
      challenge: this.$store.getters.challenge,
      eventDate:  moment().format("YYYY-MM-DDTHH:mm:ssZ"),
      errored: false,
      results: [],
      selectedClass: {},
      search: '',
      isAllSelected: false
    }
  },
  created() {
  },
  mounted () {
    this.fetchResults()
  },
  methods: {
    fetchResults() {
      ChallengeService.getResultsByChallenge(this.challenge)
        .then(response => this.results = response.data.data)
        .catch(err => {
          console.log("challenge results " + err);
          this.errored = true;
        })
    },
    classSelect (value) {
      this.selectedClass = value
    },
    getPupil(identifier) {
      return this.pupilArray.find(p => p.identifier === identifier)  
    },
    getPupilName(identifier) {
      const pupil = this.getPupil(identifier)
      return pupil === undefined ? "Unknown" : pupil.name
    },
    parseDate(date) {
      return moment(date).format('Do MMMM YYYY, h:mm a')
    },
    formatNumber(n) {
       return (n < 10 ? '0' : '') + n
    },
    parseResult(value) {
      if ([Layouts.COUNTER, Layouts.TIMEWITHCOUNT].includes(this.challenge.layout_id)) {
        return value
      } else {
        const divideValue = this.challenge.layout_id === Layouts.TIME ? 60 : 100
        const divide = this.challenge.layout_id === Layouts.TIME ? ':' : '.'
        let primary = Math.floor(value / divideValue)
        let secondary = (value - primary * divideValue)

        return this.formatNumber(primary) + divide + this.formatNumber(secondary)
      }
      

    },
  },
  components: {
    dropdown,
     datetime: Datetime,
  }
}
</script>

<style>

.button-purple:disabled {
  @apply bg-gray-500 cursor-not-allowed
}

.filter-date input {
  @apply bg-white  px-4 border rounded text-center text-gray-700 inline w-48 cursor-pointer mt-0 pt-2 h-10 !important;

}

.filter-date input :hover {
  opacity: 0.7;
}
</style>